module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHint),
      expression: "showHint"
    }],
    ref: "popover",
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": _vm.hintValue
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "temp",
      "prop": _vm.attr.columnName
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "glyphicon glyphicon-question-sign"
  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": _vm.placeholder,
      "readonly": "readonly",
      "disabled": _vm.disableField
    },
    model: {
      value: (_vm.localValue),
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "prepend",
      "icon": "search",
      "disabled": _vm.disableField
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    },
    slot: "prepend"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "delete",
      "disabled": _vm.disableField
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearField()
      }
    },
    slot: "append"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3556a5ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderInputData.vue
// module id = 910
// module chunks = 2